export function applyAbsoluteLinks(doc: Document, base: string): void {
  doc.querySelectorAll('a[href]').forEach((anchor) => {
    const href = anchor.getAttribute('href');
    if (!href) return;
    anchor.setAttribute('href', new URL(href, base).href);
    anchor.setAttribute('target', '_blank');
    anchor.setAttribute('rel', 'noopener noreferrer');
  });
}

export function removeEmptyWikiSections(doc: Document): void {
  doc.querySelectorAll('section').forEach((section) => {
    const heading = section.firstElementChild;
    if (!heading || !/^H[1-6]$/.test(heading.tagName)) return;

    let remainder = '';
    for (let node = heading.nextSibling; node; node = node.nextSibling) {
      remainder += node.textContent;
    }
    if (!remainder.trim()) {
      section.remove();
    }
  });
}
